const isLogin = () => {
    if (localStorage.getItem('tokenInfo')) {
        // console.log('isLogin',localStorage.getItem('tokenInfo'))
        return true;
    }
    return false;
}

export default isLogin;